import { render, staticRenderFns } from "./AddWPage.vue?vue&type=template&id=8da28c80&"
import script from "./AddWPage.vue?vue&type=script&lang=js&"
export * from "./AddWPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports